/**
 * Utility for cases where TypeScript considers a value to be defined,
 * but in reality it can be undefined.
 * For example when accessing an element of an array or a record.
 *
 * This is a more convenient alternative to noUncheckedIndexedAccess which
 * makes all array/record elements potentially undefined.
 */
export const maybeUndefined = <T>(value: T): T | undefined => value
